import {EditorContent, useEditor} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

type BodyEditorProps = {

    value: string;

    onChange: (
        value: string
    ) => void;

};

function BodyEditor({

                        value,

                        onChange,

                    }: BodyEditorProps)
{
    const editor =
        useEditor({

            extensions: [

                StarterKit,

            ],

            content:
            value,

            onUpdate({
                         editor,
                     }) {

                onChange(
                    editor.getHTML()
                );

            },

        });

    return (

        <div className="tiptap-editor">

            <div className="editor-toolbar">

                <button
                    type="button"
                    onClick={() =>
                        editor
                            ?.chain()
                            .focus()
                            .toggleBold()
                            .run()
                    }
                >
                    Bold
                </button>

                <button
                    type="button"
                    onClick={() =>
                        editor
                            ?.chain()
                            .focus()
                            .toggleItalic()
                            .run()
                    }
                >
                    Italic
                </button>

                <button
                    type="button"
                    onClick={() =>
                        editor
                            ?.chain()
                            .focus()
                            .toggleBulletList()
                            .run()
                    }
                >
                    List
                </button>

                <button
                    type="button"
                    onClick={() =>
                        editor
                            ?.chain()
                            .focus()
                            .toggleHeading({
                                level: 2,
                            })
                            .run()
                    }
                >
                    H2
                </button>

            </div>

            <EditorContent
                editor={editor}
            />

        </div>

    );
}

export default BodyEditor;
